import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import { selectAuth } from "../../components/auth/auth.selector";
import MealFilters from "../../components/diet/meal/MealFilters";
import MealsTable from "../../components/diet/meal/MealsTable";
import { fetchAllMealsData } from "../../redux/reducers/apiSlice";
import HelmetWrapper from "../../HelmetWrapper";

const DietMeals = () => {
  const dispatch = useDispatch();
  const { loading, allMealsData } = useSelector((state) => state.api);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const initialDietFilters = {
    isActive: "",
    isPopular: "",
    category: "",
    searchString: "",
  };
  const [dietFilters, setDietFilters] = useState(initialDietFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const mealsInitials = {
    isPage: 0,
    pagination: [],
    allMealsData: [],
  };
  const [allMeals, setAllMeals] = useState(mealsInitials);
  const [sendableQPs, setSendableQPs] = useState("");

  const onClickSearch = () => {
    setSearchFilterApplied(true);
    const searchQP = dietFilters.searchString
      ? `&search=${dietFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  function getMeals(sendableQPs, page) {
    dispatch(
      fetchAllMealsData({
        pageNo: page,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }

  useEffect(() => {
    const statusQP = dietFilters.isActive?.value
      ? `&status=${dietFilters.isActive.value}`
      : "";
    const popolarQP = dietFilters.isPopular?.value
      ? `&is_popular=${dietFilters.isPopular.value}`
      : "";
    const categoryQP = dietFilters.category?.label
      ? `&category=${dietFilters.category.label
          ?.replace(/ /g, "_")
          ?.toLowerCase()}`
      : "";
    const queryParameters = `${statusQP}${popolarQP}${categoryQP}`;
    setSendableQPs(queryParameters);
  }, [dietFilters]);

  useEffect(() => {
    getMeals(sendableQPs, allMeals.isPage + 1);
  }, [sendableQPs, allMeals.isPage]);

  useEffect(() => {
    if (allMealsData?.status && allMealsData?.data?.length > 0) {
      const { data, pagination } = allMealsData || {};

      setAllMeals({
        ...allMeals,
        allMealsData: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllMeals({
        ...allMeals,
        allMealsData: [],
        pagination: [],
      });
    }
  }, [allMealsData]);

  useEffect(() => {
    if (dietFilters.searchString?.length === 0) {
      getMeals(sendableQPs?.replace(/&?search=[^&]*/, ""), allMeals.isPage + 1);

      // dispatch(
      //   fetchAllMealsData({
      //     pageNo: allMeals.isPage + 1,
      //     limit: 10,
      //     queryParameters: sendableQPs?.replace(/&?search=[^&]*/, ""),
      //     token: decryptedText?.token,
      //   })
      // );
      setSearchFilterApplied(false);
    }
  }, [dietFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Diet Meals">
      <Container
        className="bg-cloud-k dietMealsParentContainer onlyMeals px-50px"
        fluid
      >
        <Row>
          <Col>
            <MealsStructure text={"Meal Plan"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <MealFilters
              filters={dietFilters}
              setFilters={setDietFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              callFunction={
                () => getMeals(sendableQPs, allMeals.isPage + 1)
                // dispatch(
                //   fetchAllMealsData({
                //     pageNo: allMeals.isPage + 1,
                //     limit: 10,
                //     queryParameters: sendableQPs,
                //     token: decryptedText?.token,
                //   })
                // )
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MealsTable
              decryptedText={decryptedText}
              allMeals={allMeals}
              setAllMeals={setAllMeals}
              loading={loading}
              callFunction={() => {
                getMeals(sendableQPs, allMeals.isPage + 1);

                // dispatch(
                //   fetchAllMealsData({
                //     pageNo: allMeals.isPage + 1,
                //     limit: 10,
                //     queryParameters: sendableQPs,
                //     token: decryptedText?.token,
                //   })
                // );
                // setAllMeals((prevs) => ({
                //   ...prevs,
                //   isPage: 0,
                //   pagination: [],
                // }));
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DietMeals;
